import React from 'react';
import { Link } from 'react-router-dom';
import golkaLogo from '../../assets/golka-logo.png';
import perezaryadytyLogo from '../../assets/perezaryadyty-logo.png';

const Footer = () => {
  return (
    <footer className="bg-brand-dark text-white pt-12 pb-6 mt-auto">
      <div className="container-custom">
        {/* Top row: logo + description */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3">
              {/* The logo is dark navy on transparent, i.e. invisible on this
                  dark footer — flatten it to white the same way the previous
                  inline SVG mark was white. */}
              <img
                src={golkaLogo}
                alt="Голка"
                className="h-9 w-auto brightness-0 invert"
              />
              <span className="h-7 w-px bg-gray-700" aria-hidden="true" />
              <span className="font-bold text-xl text-white tracking-tight">Voting Data API</span>
            </div>
            <p className="text-gray-400 text-sm mt-3 max-w-md">
              Система збору та публікації структурованих даних про голосування органів влади
            </p>
          </div>
        </div>

        {/* Middle row: resources + legal links */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 border-t border-gray-800 pt-8">
          <div>
            <h4 className="font-semibold text-white mb-3">Ресурси</h4>
            <ul className="space-y-2">
              <li><Link to="/docs" className="text-gray-400 hover:text-white text-sm transition-colors">Документація API</Link></li>
              <li><Link to="/#api" className="text-gray-400 hover:text-white text-sm transition-colors">API Reference</Link></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">GitHub</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-3">Правова інформація</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Умови використання</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Політика конфіденційності</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Provenance даних</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar: donor project mark + copyright */}
        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
          {/* Kept on a white plate rather than inverted: green and red carry
              meaning in this mark, so it must not be flattened. */}
          <img
            src={perezaryadytyLogo}
            alt="Перезарядити — країну тобі під силу"
            className="h-16 w-auto rounded-md bg-white p-2 shrink-0"
          />
          <span className="text-gray-400 text-xs">
            © 2025 Проєкт "Перезарядити країну тобі під силу" за підтримки NED
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;